import { render, staticRenderFns } from "./PropertyProfileForm.vue?vue&type=template&id=b7bddedc&"
import script from "./PropertyProfileForm.vue?vue&type=script&lang=ts&"
export * from "./PropertyProfileForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports